import { Button } from "@mui/material";
import LinkedIn from "../assets/LI-In-Bug.png";

export default function LinkedInButton() {
  return (
    <Button
      component="a"
      href="https://www.linkedin.com/in/vladislavs-k/"
      target="_blank"
      sx={{ fontSize: "large" }}
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      startIcon={
        <img src={LinkedIn} style={{ height: "2.5em" }} alt="LinkedIn logo" />
      }
    >
      LinkedIn
    </Button>
  );
}
